import { render } from "./GlobalOverview.vue?vue&type=template&id=349cebe5&scoped=true"
import script from "./GlobalOverview.vue?vue&type=script&lang=js"
export * from "./GlobalOverview.vue?vue&type=script&lang=js"

import "./GlobalOverview.vue?vue&type=style&index=0&id=349cebe5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349cebe5"]])

export default __exports__